
const ApiUriPrefix = "../../../../../../../api/";

export {
    ApiUriPrefix
}